<template>
  <div class="section">
    <h3 class="divider">{{details.title}}</h3>
    <div v-for="(item, index) in details.items" :key="index" class="rating-container">
      <div v-if="item.rating" class="rating">
        <Circles :rating="item.rating" />
      </div>
      <div class="rating-title">{{item.title}}</div>
    </div>  
  </div>
</template>

<script>
import Circles from '@/components/resume/Circles.vue';
export default {
  name: 'Ratings',
  components: {
    Circles,
  },
  props: {
    details: {
      type: Object,
      default: function () { return {} },
    },
  },
}
</script>

<style lang="scss" scoped>
.rating {
  margin: 0;
  position: absolute;
  right: 1rem;
  &-title {
    padding-right: 80px;
    font-size: 14px;
  }
  & li {
    display: inline-block;
    list-style-type: none;
  }
  &-container {
    position: relative;
    padding-bottom: 0.5rem;
  }
}
@media (min-width: 640px) and (max-width: 740px) {
  .rating {
    right: 0.2rem;
  }
}

</style>
